<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #default="dataTableProps">
          <SmsCampaignListItem
            :sms-campaign="dataTableProps.item"
            @deleted="dataIteratorProps.resetList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountSmsCampaignsClient } from '@/api/clients';
import SmsCampaignListItem from '@/components/SmsCampaign/SmsCampaignList/SmsCampaignListItem.vue';

export default {
  components: {
    SmsCampaignListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  methods: {
    fetchData(params) {
      return accountSmsCampaignsClient.list(this.accountId, {
        ...params,
        filter: {
          ...(params?.filter || {}),
          ...(this.since && this.until
            ? { created_between: [this.since, this.until].join(',') }
            : {}),
        },
        include: [
          'smsMessage',
          'phoneNumbersCount',
          'phoneNumbersSentCount',
          'phoneNumbersFailedCount',
        ].join(','),
      });
    },
  },
};
</script>
